import type { CityConfig } from "../city-template/types";

export const toledoConfig: CityConfig = {
  city: "Toledo",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "toledo",
  route: "/cities/toledo",
  title: "Emergency Passport Toledo, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Toledo, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Lucas County and Northwest Ohio. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Toledo, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Toledo and Northwest Ohio travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Toledo%20Ohio%20skyline%20at%20golden%20hour%20along%20the%20Maumee%20River%20with%20the%20beautiful%20Anthony%20Wayne%20Bridge%20and%20historic%20downtown%20buildings%20reflected%20in%20calm%20river%20waters%2C%20warm%20amber%20sunset%20light%20illuminating%20glass%20skyscrapers%20and%20brick%20architecture%2C%20professional%20cityscape%20wide%20panoramic%20view%2C%20vibrant%20Great%20Lakes%20region%20atmosphere&width=1800&height=700&seq=toledo-hero-oh-001&orientation=landscape",
  heroImageAlt: "Toledo Ohio skyline at golden hour along the Maumee River with the Anthony Wayne Bridge",
  geoPosition: "41.6528;-83.5379",
  geoPlacename: "Toledo, Ohio",
  lastModified: "2026-06-14",
  vitalRecordsIcon: "ri-file-text-line",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 245 miles, 3.5 hours via I-80",
  },
  nearbyCitiesZips: [
    { name: "Toledo", zips: "43601–43699" },
    { name: "Perrysburg", zips: "43551, 43552" },
    { name: "Sylvania", zips: "43560" },
    { name: "Maumee", zips: "43537" },
    { name: "Bowling Green", zips: "43402, 43403" },
    { name: "Findlay", zips: "45839, 45840" },
    { name: "Oregon", zips: "43616, 43618" },
    { name: "Rossford", zips: "43460" },
    { name: "Northwood", zips: "43619" },
    { name: "Holland", zips: "43528" },
    { name: "Adrian, MI", zips: "49221, 49224" },
    { name: "Monroe, MI", zips: "48161, 48162" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Toledo departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Michigan Border Coverage", desc: "Serving northwest Ohio and southeast Michigan" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cleveland, OH", route: "/cities/cleveland" },
    { name: "Fast passport renewal in Columbus, OH", route: "/cities/columbus-oh" },
    { name: "Emergency passport help in Findlay, OH", route: "/cities/findlay" },
    { name: "Urgent passport services in Dayton, OH", route: "/dayton" },
    { name: "Same-day passport help in Cincinnati, OH", route: "/cities/cincinnati" },
    { name: "Passport courier services in Bowling Green, OH", route: "/cities/bowling-green-oh" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Toledo remotely via secure courier. We do not have a walk-in office in Toledo — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Lucas County and Northwest Ohio travelers.",
  fpcOfficeAddress: "127 Public Square, Cleveland, OH 44114",
  fpcOfficeDistance: "Serving all of Lucas County, Northwest Ohio, and southeast Michigan",
  serviceAreaIntro: "From downtown Toledo to the suburbs of Perrysburg, Sylvania, and Maumee, from Bowling Green to the Michigan border — Fast Passport Center serves the entire Toledo metropolitan area and Northwest Ohio region. We regularly help travelers from Findlay, Oregon, and Northwood get their passports fast.",
  nearbyCitiesIntro: "We serve all Toledo neighborhoods and surrounding Northwest Ohio and southeast Michigan cities including Perrysburg, Sylvania, Maumee, Bowling Green, Findlay, Oregon, Rossford, Northwood, Holland, Adrian MI, and Monroe MI. If you are in Lucas, Wood, Fulton, or Henry counties, we have you covered.",
  howItWorksIntro: "Most Toledo travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Toledo travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Toledo and Northwest Ohio travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Toledo? Here are the most common ones we hear from Lucas County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  vitalRecordsLinks: [
    { icon: "ri-user-heart-line", label: "Birth Certificates — Ohio Department of Health", desc: "Request certified Ohio birth certificates from the ODH Bureau of Vital Statistics. Available by mail, online, or in person at the Columbus office.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-file-history-line", label: "Death Certificates — Ohio Department of Health", desc: "Obtain certified Ohio death certificates through ODH Vital Statistics. Mail, online, and in-person options available.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-hearts-line", label: "Marriage Certificates — Lucas County Probate Court", desc: "Marriage licenses and certified copies available through the Lucas County Probate Judge at 700 Adams St, Toledo, OH 43604.", url: "https://www.co.lucas.oh.us/probate" },
    { icon: "ri-file-copy-2-line", label: "Divorce Records — Lucas County Clerk of Courts", desc: "Certified divorce decrees available from the Lucas County Clerk of Courts at 700 Adams St, Toledo, OH 43604.", url: "https://www.co.lucas.oh.us/clerk" },
    { icon: "ri-global-line", label: "Order Online — VitalChek", desc: "Order Ohio birth, death, marriage, and divorce certificates online through VitalChek, the official partner of the Ohio Department of Health. Fastest online option.", url: "https://www.vitalchek.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Toledo area flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Henry R.",
      location: "Toledo, OH",
      rating: 5,
      text: "Needed my passport renewed before a cruise. Fast Passport Center delivered in 4 business days. Professional, responsive, and truly stress-free.",
      service: "Passport Renewal",
    },
    {
      name: "Lisa M.",
      location: "Perrysburg, OH",
      rating: 5,
      text: "Emergency passport for a family medical situation in Europe. Got mine in 36 hours. Their team was compassionate and incredibly efficient.",
      service: "Emergency Passport",
    },
    {
      name: "Derek S.",
      location: "Sylvania, OH",
      rating: 5,
      text: "First passport ever for a business trip to Germany. They found my nearest acceptance facility and guided me through every step. Passport in 5 days.",
      service: "New Passport",
    },
    {
      name: "Angela K.",
      location: "Maumee, OH",
      rating: 5,
      text: "Two kids needed passports for a family vacation to Mexico with only 10 days notice. Both delivered in 4 business days. This team is phenomenal.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "toledo-1",
      name: "Toledo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "435 S St Clair St",
      city: "Toledo",
      state: "OH",
      zip: "43604",
      phone: "(419) 245-1150",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Toledo",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Toledo facility. Appointments required. Photo services available nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "toledo-2",
      name: "Perrysburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 W Indiana Ave",
      city: "Perrysburg",
      state: "OH",
      zip: "43551",
      phone: "(419) 874-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Toledo suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Perrysburg, Rossford, and Bowling Green residents. Less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "toledo-3",
      name: "Sylvania Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5730 Monroe St",
      city: "Sylvania",
      state: "OH",
      zip: "43560",
      phone: "(419) 882-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northwest Toledo suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sylvania, Holland, and northwest Toledo areas. Appointment availability typically better than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "toledo-4",
      name: "Maumee Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "801 Conant St",
      city: "Maumee",
      state: "OH",
      zip: "43537",
      phone: "(419) 893-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southwest Toledo suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Maumee and Anthony Wayne area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "toledo-5",
      name: "Lucas County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "700 Adams St",
      city: "Toledo",
      state: "OH",
      zip: "43604",
      phone: "(419) 213-4484",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Toledo Courthouse",
      website: "https://www.co.lucas.oh.us/clerk",
      websiteLabel: "Lucas County Clerk",
      notes: "Alternative to post office. Good option for Lucas County residents with appointment flexibility.",
      icon: "ri-government-line",
    },
    {
      id: "toledo-6",
      name: "Findlay Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 N Main St",
      city: "Findlay",
      state: "OH",
      zip: "45840",
      phone: "(419) 422-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles south of Toledo in Hancock County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hancock County and south Lucas County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 245-mile, 3.5-hour drive to Chicago via I-80", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "NW Ohio Coverage", agency: "No tailored advice", fpc: "Yes — Tri-State expertise" },
    { feature: "Photo & Document Help", agency: "No guidance provided", fpc: "Yes — full document review included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Toledo photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or wrong form type are the #1 rejection reasons at Lucas County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Toledo applicants arrive with incorrect payment and must reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or provide notarized consent. This is a common issue for Lucas County families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Toledo travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Toledo." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Toledo address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Toledo before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Toledo for travelers with urgent flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround without driving to Chicago." },
    { q: "How fast can I renew my passport in Toledo?", a: "Fast Passport Center offers fast passport renewal in Toledo in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Toledo?", a: "The nearest regional passport agency to Toledo is the Chicago Passport Agency, approximately 250 miles away via I-80/90. For urgent processing without the drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Toledo." },
    { q: "Do you also serve southeast Michigan near Toledo?", a: "Yes. Fast Passport Center serves Toledo and the surrounding tri-state region including southeast Michigan communities like Adrian, Monroe, and Tecumseh. Our overnight courier service works from any location in the greater Toledo area regardless of state border." },
    { q: "Can I get a same-day passport appointment near Toledo?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Lucas County residents." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Toledo", address: "1 Nationwide Blvd, Toledo, OH 43604", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Sylvania", address: "6220 Monroe St, Sylvania, OH 43560", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Toledo", address: "5001 Monroe St, Toledo, OH 43623", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "Walmart Supercenter — Maumee", address: "1379 Illinois Ave, Maumee, OH 43537", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Perrysburg", address: "101 Louisiana Ave, Perrysburg, OH 43551", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Toledo West", address: "3230 W Sylvania Ave, Toledo, OH 43613", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Holland", address: "1120 S McCord Rd, Holland, OH 43528", hours: "Mon–Sun: 8AM–10PM" },
    { name: "AAA Travel — Toledo", address: "5540 Airport Hwy, Toledo, OH 43615", hours: "Mon–Fri: 8AM–5:30PM" },
  ],
  dmvLocations: [
    {
      name: "Lucas County BMV — Toledo",
      address: "1 Government Center, Toledo, OH 43604",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Lucas County BMV — Maumee",
      address: "1200 Conant St, Maumee, OH 43537",
      hours: "Mon–Fri: 8AM–5PM",
      note: "South suburban option. Typically shorter wait times than downtown.",
      featured: false,
    },
    {
      name: "Wood County BMV — Perrysburg",
      address: "202 E Brown Rd, Perrysburg, OH 43551",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Perrysburg, Bowling Green, and Wood County residents.",
      featured: true,
    },
    {
      name: "Lucas County BMV — Sylvania",
      address: "6565 W Central Ave, Toledo, OH 43617",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Northwest Toledo area option. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "TOL",
      name: "Toledo Express Airport",
      distance: "17 miles west of downtown Toledo",
      address: "11013 Airport Hwy, Swanton, OH 43558",
      note: "Primary airport serving the Toledo area. Domestic connections available. Convenient parking and check-in.",
      flightUrl: "https://www.toledoexpress.com/",
      flightLabel: "TOL Airport",
      featured: true,
    },
    {
      code: "DTW",
      name: "Detroit Metropolitan Wayne County Airport",
      distance: "65 miles northeast of Toledo",
      address: "2600 Worldgateway Pl, Detroit, MI 48242",
      note: "Major international hub for long-haul flights. Worth considering for international travel from Toledo area.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "Detroit Airport",
      featured: false,
    },
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "115 miles east of Toledo",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Alternative hub with additional international routes. United hub for long-haul connections.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: false,
    },
  ],
};